// extracted by mini-css-extract-plugin
export default {"wrapper":"ShareYourTwoCents_wrapper__edmIc","content":"ShareYourTwoCents_content__S26-E"};